import { css } from '@emotion/react';
import { getTokenValue } from '@atlaskit/tokens';

export const containerStyle = css`
  display: flex;
  padding: ${getTokenValue('space.400')} ${getTokenValue('space.300')};
  justify-content: flex-end;
  position: 'relative';
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  gap: ${getTokenValue('space.300')};
`;

export const buttonContainerStyle = css`
  display: inline-block;
  position: relative;
`;
